import TextPage from './TextPage';

export default TextPage;
